import React from "react";
import { getFieldPath } from "utils/form";
import Toggle from "../common/Toggle";

const SettingsFields = ({ name }) => (
  <Toggle name={getFieldPath(name, "validation.required")} />
);

export default SettingsFields;
